






































































































































































































































































































































































































































































































































































































































































import dayjs from 'dayjs'
import { Component, Watch, Vue } from 'vue-property-decorator'
import { Validations } from 'vuelidate-property-decorators'
import { validationMixin } from 'vuelidate'
import {
  required,
  maxLength,
  minValue,
  numeric,
  minLength,
  requiredIf,
} from 'vuelidate/lib/validators'
import controller from '@/app/ui/controllers/ProgramaticPointController'
import routeController, { Data } from '@/app/ui/controllers/RouteController'
import Button from '@/app/ui/components/Button/index.vue'
import Modal from '@/app/ui/components/Modal/index.vue'
import LoadingOverlay from '@/app/ui/components/LoadingOverlay/index.vue'
import OptionBox from '@/app/ui/components/OptionBox/index.vue'
import ProgramTextInput from './components/ProgramTextInput/index.vue'
import ProgramDropdown from './components/ProgramDropdown/index.vue'
import ProgramDatePicker from './components/ProgramDatePicker/index.vue'
import ProgramOptionRadio from './components/ProgamOptionRadio/index.vue'
import Note from '@/app/ui/components/Note/Note.vue'
import { EventBus, EventBusConstants } from '@/app/infrastructures/misc'
import { Program } from '@/domain/entities/Program'
import RadioButton from '@/app/ui/components/RadioButton/index.vue'
import * as constantData from '@/app/infrastructures/misc/Constants/programaticPoint';
import { GroupOption, LabelValue } from '@/app/ui/components/OptionBox/interfaces';
import Toggle from '@/app/ui/components/Toggle/index.vue'
import ModalAction from '@/app/ui/components/Modal/ModalAction.vue'

interface DropdownInterface {
  value: string
  label: string
  $isDisabled?: boolean
}

@Component({
  mixins: [validationMixin],
  components: {
    Button,
    Modal,
    ProgramTextInput,
    ProgramDropdown,
    ProgramDatePicker,
    ProgramOptionRadio,
    OptionBox,
    LoadingOverlay,
    RadioButton,
    Note,
    Toggle,
    ModalAction,
  },
})
export default class CreateProgram extends Vue {
  controller = controller
  routeController = routeController
  maxCount = 30
  form = {
    programName: '',
    userTarget: <LabelValue<constantData.UserType> | null>null,
    fileUsers: new File([], ''),
    triggerBy: <LabelValue<string> | null>null,
    routes: <Data[]>[],
    scheduleDate: '',
    scheduleTime: '',
    invoiceSource: [] as Array<string>,
    paymentMethod: [] as Array<string>,
    minimumTransaction: 0,
    purpose: [] as Array<string>,
    pointValueType: 'fixed',
    pointAmount: 0,
    percentOfTransaction: 0,
    maxAmountGiven: null as number | null,
    pointExpirationType: 'days',
    expiredDate: null as string | null,
    expiryDay: 0,
    limitPerDay: 0,
    limitPerUser: 0,
    budgetSource: <LabelValue<string> | null>null,
    budgetAmount: <null | number | undefined>null,
    budgetSourceOther: '',
    startDate: '',
    endDate: '',
    startTime: '',
    endTime: '',
    membershipLevel: 'Premium',
  }
  successModal = false
  showModalConfirm = false
  todayDate = dayjs().format('YYYY-MM-DD')
  disableLimitUser = false
  constants = constantData
  labelOfPercentagePoint = 'Percentage of Total Transaction'
  budgetAmountActive = false
  budgetAmountDisabledOnEdit = false

  created(): void {
    this.isEditMode && controller.setLoading(true)
    routeController.getCityList()
    controller.getTriggers()
    controller.getPointPurposes()
    controller.getPaymentMethodList()

    EventBus.$on(EventBusConstants.SAVE_PROGRAM_SUCCESS, () => {
      this.successModal = true
    })
  }

  @Watch('form', { deep: true })
  onFormChanged(val: Record<string, any>): void {
    if (val.triggerBy?.value === 'ON_SCHEDULE') {
      this.form.startDate = this.programDetail.startDate
        ? dayjs(this.programDetail.startDate).format('YYYY-MM-DD')
        : ''
      this.form.startTime = this.programDetail.startDate
        ? dayjs(this.programDetail.startDate).format('HH:mm:ss')
        : ''
      this.form.endDate = this.programDetail.endDate
        ? dayjs(this.programDetail.endDate).format('YYYY-MM-DD')
        : ''
      this.form.endTime = this.programDetail.endDate
        ? dayjs(this.programDetail.endDate).format('HH:mm:ss')
        : ''
      this.budgetAmountActive = false
      this.form.budgetAmount = null
    } else {
      this.form.scheduleDate = this.programDetail.scheduledAt
        ? dayjs(this.programDetail.scheduledAt).format('YYYY-MM-DD')
        : ''
      this.form.scheduleTime = this.programDetail.scheduledAt
        ? dayjs(this.programDetail.scheduledAt).format('HH:mm:ss')
        : ''
    }
  }

  @Watch('form.triggerBy', { deep: true })
  onTriggerChanged(trigger: DropdownInterface, oldTrigger: DropdownInterface): void {
    // Select Complete Profile
    if (trigger && trigger.value === constantData.TriggerType.COMPLETE_PROFILE) {
      this.form.limitPerUser = 1
      this.disableLimitUser = true
    }
    // UnSelect Complete Profile
    if (oldTrigger && oldTrigger.value === constantData.TriggerType.COMPLETE_PROFILE) {
      this.form.limitPerUser = 0
      this.disableLimitUser = false
    }
  }

  @Watch('form.userTarget', { deep: true })
  onUserTargetChanged(newVal: Record<string, string | boolean> | null): void {
    if (newVal && newVal['value'] === constantData.UserType.MEMBERSHIP) {
      this.form.pointValueType = constantData.PointValueType.PERCENTAGE
      this.labelOfPercentagePoint = 'Percentage of Total Shipping Fee'
    } else {
      this.labelOfPercentagePoint = 'Percentage of Total Transaction'
    }
  }

  @Watch('routeOptions')
  onRouteOptionsChanged(): void {
    if (this.isEditMode) {
      controller.getProgramDetail(this.$route.query.id as string)
    }
  }

  @Watch('programDetail')
  onProgramDetailChanged(val: Program): void {
    this.form = {
      programName: val.name || '',
      userTarget:
        this.constants.TARGET_OPTIONS.find(
          item => item.value === val.target
        ) || null,
      fileUsers: new File([], val.selectedUsers as string),
      triggerBy:
        this.triggerOptions.find(item => item.value === val.triggerBy) || null,
      routes:
        this.routeOptions.filter(item =>
          val.routes?.map(r => r.id).includes(Number(item.value))
        ) || [],
      scheduleDate: val.scheduledAt
        ? dayjs(val.scheduledAt).format('YYYY-MM-DD')
        : '',
      scheduleTime: val.scheduledAt
        ? dayjs(val.scheduledAt).format('HH:mm:ss')
        : '',
      invoiceSource: val.invoiceSource ? val.invoiceSource.split(',') : [],
      paymentMethod: val.paymentMethodUsed
        ? val.paymentMethodUsed.split(',')
        : [],
      minimumTransaction: val.minimumTransaction || 0,
      purpose: val.purpose ? val.purpose.split(',') : ([] as Array<string>),
      pointValueType:
        val.percentOfTransaction && val.percentOfTransaction > 0
          ? constantData.PointValueType.PERCENTAGE
          : constantData.PointValueType.FIXED,
      pointAmount: val.points || 0,
      percentOfTransaction: val.percentOfTransaction || 0,
      maxAmountGiven: val.maxAmountGiven || 0,
      pointExpirationType: val.expiredDate ? 'exact-date' : 'days',
      expiredDate: val.expiredDate
        ? dayjs(val.expiredDate).format('YYYY-MM-DD')
        : null,
      expiryDay: val.expiryDay || 0,
      limitPerDay: val.limitPerDay || 0,
      limitPerUser: val.limitPerUser || 0,
      budgetSource:
        this.constants.BUDGET_SOURCE.find(budgetSource => {
          if (val.budgetSource?.startsWith('OTHERS'))
            return budgetSource.value === 'OTHERS'

          return budgetSource.value === val.budgetSource
        }) || null,
      budgetSourceOther: val.budgetSource?.startsWith('OTHERS')
        ? val.budgetSource.substr(7)
        : '',
      budgetAmount: val.budgetAmount,
      startDate: val.startDate ? dayjs(val.startDate).format('YYYY-MM-DD') : '',
      endDate: val.endDate ? dayjs(val.endDate).format('YYYY-MM-DD') : '',
      startTime: val.startDate ? dayjs(val.startDate).format('HH:mm:ss') : '',
      endTime: val.endDate ? dayjs(val.endDate).format('HH:mm:ss') : '',
      membershipLevel: val.membershipLevel || 'Premium',
    }

    if (
      this.form.budgetAmount &&
      this.form.budgetAmount > 0 &&
      !this.isTriggeredByOnSchedule
    ) {
      this.budgetAmountActive = true
      this.budgetAmountDisabledOnEdit = true
    }
  }

  @Watch('form.triggerBy')
  onTriggerByChanged(
    newValue: { label: string; value: constantData.TriggerType } | undefined,
    previousVal: { label: string; value: constantData.TriggerType } | undefined
  ): void {
    const triggers = [constantData.TriggerType.PAID_ALL, constantData.TriggerType.SHIPMENT_PAID_BY_CITY]
    if (
      triggers.includes(<constantData.TriggerType>previousVal?.value || '') &&
      !triggers.includes(<constantData.TriggerType>newValue?.value || '')
    ) {
      this.form.pointValueType = constantData.PointValueType.FIXED
    }

    if (this.isMemberUser) {
      this.form.pointValueType = constantData.PointValueType.PERCENTAGE
    }
  }

  @Validations()
  validations(): Record<string, unknown> {
    let validate = {
      form: {
        programName: { required, maxLength: maxLength(this.maxCount) },
        userTarget: { required },
        triggerBy: { required },
        scheduleDate: {},
        scheduleTime: {},
        purpose: { required, minLength: minLength(1) },
        invoiceSource: {
          required: requiredIf(() => this.triggedByInvoicePaidAll),
        },
        minimumTransaction: {
          required: requiredIf(
            () => this.triggedByInvoicePaidAll || this.triggedByShipmentPaidCity
          ),
          minValue: minValue(
            this.triggedByInvoicePaidAll || this.triggedByShipmentPaidCity
              ? 1
              : 0
          ),
        },
        paymentMethod: {
          required: requiredIf(
            () => this.triggedByInvoicePaidAll || this.triggedByShipmentPaidCity
          ),
          minLength: minLength(
            this.triggedByInvoicePaidAll || this.triggedByShipmentPaidCity
              ? 1
              : 0
          ),
        },
        pointAmount: {
          required: requiredIf(() => this.form.pointValueType === constantData.PointValueType.FIXED),
          minValue: minValue(this.form.pointValueType === constantData.PointValueType.FIXED ? 1 : 0),
          numeric,
        },
        percentOfTransaction: {
          required: requiredIf(() => this.form.pointValueType === constantData.PointValueType.PERCENTAGE),
          minValue: minValue(this.form.pointValueType === constantData.PointValueType.PERCENTAGE ? 1 : 0),
          numeric,
        },
        maxAmountGiven: {
          required: requiredIf(() => this.form.pointValueType === constantData.PointValueType.PERCENTAGE),
          minValue: minValue(this.form.pointValueType === constantData.PointValueType.PERCENTAGE ? 1 : 0),
          numeric,
        },
        expiredDate: {
          required: requiredIf(
            () => this.form.pointExpirationType === 'exact-date'
          ),
        },
        expiryDay: {
          required: requiredIf(() => this.form.pointExpirationType === 'days'),
          minValue: minValue(this.form.pointExpirationType === 'days' ? 1 : 0),
        },
        limitPerDay: { required, minValue: minValue(1) },
        limitPerUser: {
          required,
          minValue: minValue(1),
        },
        budgetSource: { required: requiredIf(() => !this.isEditMode) },
        budgetAmount: {
          required: requiredIf(() => this.budgetAmountActive && !this.isTriggeredByOnSchedule) ,
          minValue: this.budgetAmountActive && !this.isTriggeredByOnSchedule ? minValue(1): true,
        },
        budgetSourceOther: {
          required: requiredIf(
            () => this.form.budgetSource?.value === 'OTHERS'
          ),
        },
        startDate: {},
        startTime: {},
        endDate: {},
        endTime: {},
        fileUsers: {
          name: {
            required: requiredIf(
              () => this.form.userTarget?.value === constantData.UserType.SELECTED
            ),
          },
        },
      },
    }

    if (this.form.triggerBy?.value === constantData.TriggerType.ON_SCHEDULE) {
      validate = {
        form: {
          ...validate.form,
          scheduleDate: { required },
          scheduleTime: { required },
        },
      }
    } else {
      validate = {
        form: {
          ...validate.form,
          startDate: { required },
          startTime: { required },
          endDate: { required },
          endTime: { required },
        },
      }
    }

    return validate
  }

  get isEditMode(): boolean {
    return (
      this.$route.query &&
      this.$route.query.edit === '1' &&
      this.$route.query.id !== null
    )
  }

  private eventTargetUserType(): void {
    this.form.invoiceSource = []
  }

  get getOptionsTriggeredInvoicePaidAll(): GroupOption<string, string>[] {
    return this.isMemberUser ? this.constants.INVOICE_SOURCE_MEMBERSHIP : this.constants.INVOICE_SOURCE
  }

  private _setDisabledTriggerOptions(trigger: Record<string, string>): boolean {
    return (trigger.value !== constantData.TriggerType.PAID_ALL &&
      this.form.userTarget &&
      [constantData.UserType.PHONE_NUMBER, constantData.UserType.MEMBERSHIP].includes(this.form.userTarget.value)) ||
    ([constantData.TriggerType.REGISTRATION, constantData.TriggerType.REFERRAL_INVITEE].includes(<constantData.TriggerType>trigger.value) &&
      this.form.userTarget &&
      this.form.userTarget.value === constantData.UserType.SELECTED) ||
    false
  }

  get triggerOptions(): DropdownInterface[] {
    return controller.triggerData.map(trigger => ({
      ...trigger,
      $isDisabled: this._setDisabledTriggerOptions(trigger)
    }))
  }

  get routeOptions(): Data[] {
    return routeController.cityData
  }

  get programDetail(): Program {
    return controller.programDetail
  }

  get attachmentName() {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return this.form.fileUsers ? this.form.fileUsers.name! : null
  }

  get pointPurposeOptions(): Record<string, any> {
    return controller.pointPurposes.map(item =>
      Object.assign(
        {},
        {
          label: item.name,
          value: item.id,
        }
      )
    )
  }

  get paymentMethodList(): { label: string; value: string }[] {
    return controller.paymentMethods.map(item => ({
      label: item,
      value: item,
    }))
  }

  get triggedByInvoicePaidAll(): boolean {
    return this.form.triggerBy?.value === constantData.TriggerType.PAID_ALL
  }

  get triggedByShipmentPaidCity(): boolean {
    return this.form.triggerBy?.value === constantData.TriggerType.SHIPMENT_PAID_BY_CITY
  }

  get isTriggeredByOnSchedule(): boolean {
    return this.form.triggerBy?.value === constantData.TriggerType.ON_SCHEDULE
  }

  get setBgClassSwitcherBudgetAmount(): string {
    return this.budgetAmountDisabledOnEdit &&
      this.budgetAmountActive ? 'bg-gray-2' : 'bg-bgPrimary'
  }

  get budgetAmountError(): string {
    if (
      this.$v.form.budgetAmount?.$dirty &&
      !this.$v.form.budgetAmount?.required ||
      !this.$v.form.budgetAmount?.minValue
    ) {
      return `Budget amount can’t be 0`
    }

    if (
      this.form.budgetAmount &&
      (
        !this.isEditMode &&
        this.$v.form.pointAmount?.$dirty ||
        this.isEditMode
      ) &&
      +this.form.budgetAmount < this.form.pointAmount
    ) {
      return 'Budget amount must be higher than the point amount'
    }

    if (
      this.form.budgetAmount &&
      this.form.maxAmountGiven &&
      (
        !this.isEditMode &&
        this.$v.form.maxAmountGiven?.$dirty ||
        this.isEditMode
      ) &&
      +this.form.budgetAmount < this.form.maxAmountGiven
    ) {
      return 'Budget amount must be higher than the point amount'
    }

    return ''
  }

  private setSaldoPurposePayload(value: string): void {
    if (this.form.purpose.includes(value)) {
      this.form.purpose = this.form.purpose.filter(item => item !== value)
    } else {
      this.form.purpose.push(value)
    }
  }

  private setInvoiceSourcePayload(value: string): void {
    if (this.form.invoiceSource.includes(value)) {
      this.form.invoiceSource = this.form.invoiceSource.filter(
        item => item !== value
      )
    } else {
      this.form.invoiceSource.push(value)
    }
  }

  get isMemberUser(): boolean {
   return !!(this.form.userTarget && this.form.userTarget.value === constantData.UserType.MEMBERSHIP)
  }

  private setInvoiceSourcePayloadGroup(value: string): void {
    const group = this.getOptionsTriggeredInvoicePaidAll.find(
      source => source.group === value
    )
    if (
      group?.options?.every(
        option => !this.form.invoiceSource.includes(option.value)
      )
    ) {
      const groupOption: LabelValue<string>[] = group.options
      let newGroup = groupOption.map(option => option.value)

      if (this.isMemberUser) {
        newGroup = groupOption.filter(option => !option['disabled']).map(option => option.value)
      }

      this.form.invoiceSource = [
        ...this.form.invoiceSource,
        ...newGroup
      ]
    } else {
      this.form.invoiceSource = this.form.invoiceSource.filter(
        item => !group?.options?.find(option => option.value === item)
      )
    }
  }

  private setPaymentMethodPayload(value: string): void {
    if (this.form.paymentMethod.includes(value)) {
      this.form.paymentMethod = this.form.paymentMethod.filter(
        item => item !== value
      )
    } else {
      this.form.paymentMethod.push(value)
    }
  }

  private onFileChange($event: File) {
    this.$v.form.fileUsers?.$touch()
    this.form.fileUsers = $event
  }

  private onCreateProgram(): void {
    this.$v.$touch()

    if (!this.$v.form.$invalid) {
      const form = {
        ...this.form,
        isPercentage: this.form.pointValueType === constantData.PointValueType.PERCENTAGE,
        isExactDate: this.form.pointExpirationType === 'exact-date',
      }
      if (this.isEditMode) {
        controller.sendProgram({
          ...form,
          programId: <string>this.$route.query.id,
        })
      } else {
        controller.sendProgram(form)
      }
    } else {
      Vue.notify({
        title: 'Create Program',
        text: 'Please check every invalid form',
        type: 'error',
        duration: 5000,
      })
    }
  }

  private onCloseSuccessModal() {
    this.successModal = false
    this.$router.push({ name: 'ProgramaticPointPage' })
  }

  private virtualAccountClass(bankName: string): string {
    if (bankName.length <= 19) return 'uppercase'

    return 'capitalize'
  }

  get disableStartDate(): boolean {
    if (!this.form.triggerBy) {
      return true
    }

    if (this.form.triggerBy.value === constantData.TriggerType.ON_SCHEDULE) {
      return true
    }

    return (
      this.isEditMode && (this.programDetail.status !== 'PENDING')
    )
  }

  get targetOptions(): DropdownInterface[] {
    return this.constants.TARGET_OPTIONS.map(target => ({
      ...target,
      $isDisabled:
        ([constantData.UserType.PHONE_NUMBER, constantData.UserType.MEMBERSHIP].includes(target.value) &&
          this.form.triggerBy &&
          this.form.triggerBy.value !== constantData.TriggerType.PAID_ALL) ||
        (target.value === constantData.UserType.SELECTED &&
          this.form.triggerBy &&
          [constantData.TriggerType.REGISTRATION, constantData.TriggerType.REFERRAL_INVITEE].includes(
            <constantData.TriggerType>this.form.triggerBy.value
          )) ||
        false,
    }))
  }

  onChangeBudgetToggle(): void {
    this.budgetAmountActive = !this.budgetAmountActive
    this.form.budgetAmount = null
  }

  onCancel(): void {
    this.showModalConfirm = true
  }

  goBack(): void {
    this.showModalConfirm = false
  }

  doActionConfirm(): void {
    this.$router.push('/saldo')
  }

  beforeDestroy(): void {
    EventBus.$off(EventBusConstants.SAVE_PROGRAM_SUCCESS)
  }
}
